var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sftp-files-header"},[_c('div',{staticClass:"d-flex flex-fill"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("sections.sftpFiles.header.files"))+"\n    ")])]),_c('div',{staticClass:"sftp-files-header__date"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("sections.sftpFiles.header.creationDate"))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }